module.exports = __webpack_public_path__ + "static/media/sg8sj.f038ae2e.png";